/**
 * 部门管理 API
 */

import { http } from '../request';
import type { Dept } from '../../types/dept';

/**
 * 获取部门树
 */
export function getDeptTree(): Promise<Dept[]> {
  return http.get<Dept[]>('/system/dept/tree');
}

/**
 * 根据 ID 查询部门详情
 */
export function getDeptById(id: number): Promise<Dept> {
  return http.get<Dept>(`/system/dept/${id}`);
}

/**
 * 创建部门
 */
export function createDept(data: Dept): Promise<void> {
  return http.post('/system/dept', data);
}

/**
 * 更新部门
 */
export function updateDept(data: Dept): Promise<void> {
  return http.put(`/system/dept/${data.id}`, data);
}

/**
 * 删除部门
 */
export function deleteDept(id: number): Promise<void> {
  return http.delete(`/system/dept/${id}`);
}
